import { render, staticRenderFns } from "./TileQuality.vue?vue&type=template&id=8754d3fa"
import script from "./TileQuality.vue?vue&type=script&lang=js"
export * from "./TileQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports